import PostPage from './PostPage'

export default PostPage
